<span [class]="entailmentClass()">{{ entailmentText() }}</span>
